import * as React from "react";
import { useState } from "react";
import { useFormikContext } from "formik";
import { Button, Input } from "components/bootstrap";
import { Select } from "components/common";
import ServiceAccountKeyFilePicker from "../repository-management/ServiceAccountKeyFilePicker";
const AUTH_OPTIONS = [
  { value: "automatic", label: "Automatic" },
  { value: "service_account_key", label: "Service account key" }
];
export const validateGcsCredentialsForm = (values) => {
  const errors = {};
  if (values.auth_mode === "service_account_key" && (!values.service_account_key || "delete_value" in values.service_account_key)) {
    errors.service_account_key = "Required when using Service account key authentication.";
  }
  return errors;
};
const GcsCredentialsFormFields = ({ keyIsSet, clientEmail = null }) => {
  const { values, errors, setFieldValue } = useFormikContext();
  const [replacingKey, setReplacingKey] = useState(false);
  const [fileName, setFileName] = useState();
  const keyError = errors.service_account_key;
  const showKeyStatus = keyIsSet && !replacingKey;
  const setKey = (key) => setFieldValue("service_account_key", key);
  const startReplacing = () => {
    setKey(void 0);
    setReplacingKey(true);
  };
  const keepCurrentKey = () => {
    setKey({ keep_value: true });
    setFileName(void 0);
    setReplacingKey(false);
  };
  const handleAuthModeChange = (authMode) => {
    if (authMode === values.auth_mode) {
      return;
    }
    if (authMode === "automatic") {
      setKey(void 0);
      setFileName(void 0);
      setReplacingKey(false);
    } else {
      setKey(keyIsSet ? { keep_value: true } : void 0);
      setReplacingKey(false);
    }
    setFieldValue("auth_mode", authMode);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-auth-mode",
      label: "Authentication Type",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "credentialsAuthMode",
        name: "auth_mode",
        placeholder: "Select Authentication Type",
        "aria-label": "Select authentication type",
        options: AUTH_OPTIONS,
        onChange: handleAuthModeChange,
        clearable: false,
        value: values.auth_mode
      }
    )
  ), values.auth_mode === "service_account_key" && /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "credentials-service-account-key",
      label: "Service Account Key",
      error: keyError,
      bsStyle: keyError ? "error" : void 0,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      help: clientEmail ? `Service account: ${clientEmail}. Upload a new JSON key file to replace the stored key.` : "The JSON key file of a service account with read access to the bucket."
    },
    showKeyStatus ? /* @__PURE__ */ React.createElement("div", null, "A key is set.", " ", /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: startReplacing }, "Replace key")) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      ServiceAccountKeyFilePicker,
      {
        fileName,
        onFileRead: (content, name) => {
          setKey({ set_value: content });
          setFileName(name);
        }
      }
    ), keyIsSet && /* @__PURE__ */ React.createElement(Button, { type: "button", onClick: keepCurrentKey }, "Keep current key"))
  ));
};
export default GcsCredentialsFormFields;
